import { Loader, QueryBoundary } from '@outdoria/ui';
import { SelectEntityButton } from '../../components';

import s from './GatheringSpotsSelectView.module.scss';

export const GatheringSpotsSelectView = () => (
  <QueryBoundary fallback={<Loader />}>
    <Load />
  </QueryBoundary>
);

const Load = () => {
  return (
    <div className={s.view}>
      <SelectEntityButton
        description="Gathering spots: view, create, update, delete"
        icon="Pin"
        link="spots"
        title="Gathering spot"
      />

      <SelectEntityButton
        description="Gathering spot types: view, create, update, delete"
        icon="Pin"
        link="types"
        title="Gathering spot type"
      />
    </div>
  );
};
